module.exports = __webpack_public_path__ + "static/img/headband_white.78daf9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headband_white.png
// module id = HTli
// module chunks = 1